export enum SsoCallbackPageTestIds {
  PROGRESS = 'sso-callback-progress',
}
